/** Normalize API/date values to YYYY-MM-DD for <input type="date">. */
export function formatDateForInput(value) {
  if (!value) return "";
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const y = value.getFullYear();
    const m = String(value.getMonth() + 1).padStart(2, "0");
    const d = String(value.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }
  const str = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(str)) return str.slice(0, 10);
  const parsed = new Date(str);
  if (!Number.isNaN(parsed.getTime())) {
    const y = parsed.getFullYear();
    const m = String(parsed.getMonth() + 1).padStart(2, "0");
    const d = String(parsed.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }
  return "";
}

/** Calculate completed age in years from YYYY-MM-DD date string. */
export function calculateAgeFromDob(dobString) {
  if (!dobString) return "";
  const [y, m, d] = dobString.split("-").map(Number);
  if (!y || !m || !d) return "";
  const dob = new Date(y, m - 1, d);
  if (Number.isNaN(dob.getTime())) return "";
  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const hadBirthday =
    today.getMonth() > dob.getMonth()
    || (today.getMonth() === dob.getMonth() && today.getDate() >= dob.getDate());
  if (!hadBirthday) age -= 1;
  return age >= 0 ? String(age) : "";
}

export function mapPatientToForm(patient) {
  if (!patient) return {};
  const phones = Array.isArray(patient.phone_numbers) && patient.phone_numbers.length
    ? patient.phone_numbers
    : [""];
  const dateOfBirth = formatDateForInput(patient.date_of_birth);
  const ageYears = dateOfBirth
    ? (patient.age_years ?? calculateAgeFromDob(dateOfBirth))
    : (patient.age_years ?? "");
  return {
    patient_id: patient.patient_id,
    patient_name: patient.patient_name || "",
    profile_pic_path: patient.profile_pic_path || "",
    gender: patient.gender || "",
    date_of_birth: dateOfBirth,
    age_years: ageYears,
    referred_by_doctor_id: patient.referred_by_doctor_id ?? "",
    referred_date: formatDateForInput(patient.referred_date),
    health_passport_no: patient.health_passport_no || "",
    blood_group_id: patient.blood_group_id ?? "",
    nationality_id: patient.nationality_id ?? "",
    country_id: patient.country_id ?? "",
    location_id: patient.location_id ?? "",
    address_line_1: patient.address_line_1 || "",
    address_line_2: patient.address_line_2 || "",
    city_id: patient.city_id ?? "",
    state_id: patient.state_id ?? "",
    postal_code: patient.postal_code || "",
    country_code: patient.country_code || "",
    phone_numbers: phones,
    email_address: patient.email_address || "",
    emergency_contact_1_name: patient.emergency_contact_1_name || "",
    emergency_contact_1_relationship_id: patient.emergency_contact_1_relationship_id ?? "",
    emergency_contact_1_country_code: patient.emergency_contact_1_country_code || "",
    emergency_contact_1_phone: patient.emergency_contact_1_phone || "",
    emergency_contact_1_email: patient.emergency_contact_1_email || "",
    emergency_contact_2_name: patient.emergency_contact_2_name || "",
    emergency_contact_2_relationship_id: patient.emergency_contact_2_relationship_id ?? "",
    emergency_contact_2_country_code: patient.emergency_contact_2_country_code || "",
    emergency_contact_2_phone: patient.emergency_contact_2_phone || "",
    emergency_contact_2_email: patient.emergency_contact_2_email || "",
  };
}

export const emptyPatientForm = () => mapPatientToForm({ phone_numbers: [""] });
